/* ── Divider ────────────────────────────────────────────── */
export const Divider = ({ className = "" }) => (
  <div className={`st-divider ${className}`} />
);
